/**
 * Flags that Zone.js reads at load time. This file MUST be imported before
 * `zone.js` (see polyfills.ts). Webpack hoists imports, so the flags cannot
 * live next to `import 'zone.js'` in the same file.
 *
 * Leave touch/wheel unpatched so A-Frame can keep distinct native listeners
 * on the canvas: look-controls uses {passive: true}, cursor uses
 * {passive: false} + preventDefault() on touchstart. Zone.js otherwise merges
 * them into one passive listener and Chrome logs
 * "Unable to preventDefault inside passive event listener".
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'touchstart',
  'touchmove',
  'touchend',
  'wheel',
];
